// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1r2Id","header":"PatientQuestionnaire_header__38c2o","info":"PatientQuestionnaire_info__WO6Yg"};